import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import '../styles/PcMenu.css';

const PcMenu = ({ closeMenu }) => {
    // Accept closeMenu as a prop { closeMenu}
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, []);


    return (
        <ul className="pc-menu">
            {!isAuthenticated && (
                <li>
                    <NavLink
                        exact="true"
                        to="/"
                        className={({ isActive }) => (isActive ? "active-link" : undefined)}
                        onClick={closeMenu} // Close menu on click
                    >
                        Home
                    </NavLink>
                </li>
            )}

            <li>
                <NavLink
                    to="/about-us"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                    About Us
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="/contact-us"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                    Contact Us
                </NavLink>
            </li>
              <li>
                <NavLink
                    to="/charity"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                  Our Charity
                </NavLink>
            </li>

            {!isAuthenticated && (
                <>
                    <li>
                        <NavLink
                            to="/login"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            Get Started
                        </NavLink>
                    </li>
                </>
            )}
        </ul>
    );
};

export default PcMenu;
